import LinkExternal from '../LinkExternal';
import LinkInternal from '../LinkInternal';
import Item from '../Item';

export default [
    {
        component: Item,
        props: {
            render: new LinkExternal({
                href: 'https://wiki.korpus.cz/doku.php/cnk:dialekt',
                text: 'Korpus DIALEKT',
            }),
        },
    },
    {
        component: Item,
        props: {
            render: new LinkExternal({
                href: 'https://wiki.korpus.cz/doku.php/cnk:ortofon',
                text: 'Korpus ORTOFON',
            }),
        },
    },
    {
        component: Item,
        props: {
            render: new LinkExternal({
                href: 'https://wiki.korpus.cz/doku.php/cnk:oral',
                text: 'Korpus ORAL',
            }),
        },
    },
    {
        component: Item,
        props: {
            render: new LinkInternal({
                id: 'dialectPanel',
                text: 'Popis nářečního členění ČR',
            }),
        },
    },
    {
        component: Item,
        props: {
            render: new LinkExternal({
                href: 'https://wiki.korpus.cz/doku.php/cnk:dialekt:mapa',
                text: 'Mapa nářečí ČR',
            }),
        },
    },
    {
        component: Item,
        props: {
            render: new LinkExternal({
                href: 'https://wiki.korpus.cz/doku.php/cnk:dialekt:archivhlasek',
                text: 'Archiv nářečních hlásek ČJ',
            }),
        },
    },
    {
        component: Item,
        props: {
            render: new LinkExternal({
                href: 'https://kontext.korpus.cz/first_form',
                text: 'KonText',
            }),
        },
    },
];
